<template>
    <div class="alert alert-secondary border mb-3">
        <div class="alert-heading mb-4">
            <h5 class="float-right mb-0"><span class="badge badge-primary" :class="'badge-'+stateColor">{{$t(`js.backend.campaign_controls.state.${currentState}`)}}</span></h5>
            <h4 class="mb-0">{{ $t(`js.backend.campaign_controls.state_header.${currentState}`) }}</h4>
        </div>
        <div v-show="currentState === 'ready'">
            <div class="row">
                <div class="d-flex flex-column justify-content-between text-center col-6 border-right">
                    <b class="mb-2">{{ $t('js.backend.campaign_controls.scheduled_send_out') }}</b>
                    <input class="form-control mb-3" type="datetime-local" id="campaign_schedule_at"
                           name="campaign[schedule_at]" :min="minDate" v-model="scheduleAt">
                    <div v-if="errors.length > 0" class="bg-danger p-2 mb-3">
                        <p class="mb-0 text-white" v-for="error in errors">{{error}}</p>
                    </div>
                    <button type="button" class="btn btn-primary" @click="schedule">{{ $t('js.backend.campaign_controls.send_on_schedule') }}</button>
                </div>

                <div class="d-flex flex-column justify-content-between text-center col-6">
                    <b>{{ $t('js.backend.campaign_controls.immediate_send_out') }}</b>
                    <button type="button" class="btn btn-primary" @click="deliver" :disabled="recipientCount < 1">{{ $t('js.backend.campaign_controls.send_out_now') }}</button>
                </div>
            </div>
        </div>
        <div v-if="currentState === 'scheduled'" class="text-center">
            <p v-html="$t(`js.backend.campaign_controls.state_body.${currentState}`,
             {recipientCount: recipientCount, scheduledAt: formattedScheduledAt})"></p>
            <button type="button" class="btn btn-danger" @click.prevent="deschedule">{{ $t('js.backend.campaign_controls.cancel_schedule') }}</button>
        </div>
        <div v-if="currentState === 'queued'">
            <p v-html="$t(`js.backend.campaign_controls.state_body.${currentState}`)"></p>
            <button type="button" class="btn btn-danger" @click.prevent="abort">{{ $t('js.backend.campaign_controls.abort') }}</button>
        </div>
        <div v-if="currentState === 'sending'">
            <Progress :count="campaign.sent_count" :total="recipientCount" class="mb-3"/>
            <button type="button" class="btn btn-danger" @click.prevent="abort">{{ $t('js.backend.campaign_controls.abort') }}</button>
        </div>
        <div v-if="currentState === 'stopped'">
            <p v-html="$t(`js.backend.campaign_controls.state_body.${currentState}`, {sentCount: campaign.sent_count || 0})"></p>
        </div>
        <div v-if="currentState === 'sent'">
                <p v-if="campaign.schedule_at"
                   v-html="$t('js.backend.campaign_controls.state_body.sent.scheduled', {scheduledAt: formattedScheduledAt})">

                </p>
                <p v-html="$t('js.backend.campaign_controls.state_body.sent.finished', {sentAt: formattedSentAt, sentCount: campaign.sent_count})">

                </p>
        </div>
    </div>
</template>

<script>

    import apiClient from "../../packs/frontend/apiClient"
    import Progress from "../shared/Progress";

    // Since parsing a date will take time zone into account,  but printing a date will not,
    // then we simply ignore the time zone info.
    // This is okay, since rails will return date times in a configured time zone.
    // Fx. 2020-11-30T10:45:55.024+01:00 will become 2020-11-30T10:45:55.024 which
    // formats nicely without any offset
    function parseWoTz(dateString){
      return Date.parse(dateString.split('+')[0])
    }

    export default {
        name: "CampaignControls",
      components: {Progress},
      props: {
            campaign: Object,
            recipientCount: Number
        },
        data(){
            return {
                scheduleAt: null,
                errors: []
            }
        },
        computed: {
            currentState(){
                return this.campaign.workflow_state
            },
            stateColor(){
                switch(this.currentState){
                    case 'ready':
                        return 'success'
                    case 'stopped':
                    case 'failed':
                        return 'danger'
                    default:
                        return 'primary'
                }
            },
            minDate(){
                let d = new Date()
                let dmonth = d.getMonth()+1
                let month = dmonth < 10 ? "0"+(dmonth) : dmonth
                let time = d.getFullYear()+"-"+month+"-"+d.getDate()+"T00:00"

                return time
            },
            formattedScheduledAt(){
                return this.$d(parseWoTz(this.campaign.schedule_at),'long')
            },
            formattedSentAt(){
                return this.$d(parseWoTz(this.campaign.sent_at),'long')
            }
        },
        methods:{
            deliver(){
                if(this.recipientCount < 1) return
                apiClient.patch(this.campaign.id+'/deliver').then()
            },
            schedule(){
                apiClient.patch(this.campaign.id+'/schedule', {schedule_at: this.scheduleAt}).then(res => {
                    if(res.data.errors){
                        this.errors = res.data.errors
                    }
                })
            },
            deschedule(){
                apiClient.patch(this.campaign.id+'/deschedule').then(res => {
                    if(res.status >= 200 && res.status < 300){
                        this.errors = []
                    }
                })
            },
            abort(){
                apiClient.patch(this.campaign.id+'/abort').then()
            }
        },
        channels: {
            CampaignChannel: {
                received(data) {
                    this.campaign = Object.assign(this.campaign, data)
                }
            }
        },
        mounted(){
            this.$cable.subscribe({
                channel: 'CampaignChannel',
                id: this.campaign.id });
            this.scheduleAt = this.campaign.schedule_at
        }
    }
</script>